import { memo } from 'react'
import styles from './index.module.less'

export default memo(function ProjectDashboard() {
  return <div className={styles.container}></div>
})
